export default __webpack_public_path__ + "static/media/tiktok.0b3f47d2.svg";